import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
    id_curso_escolar:       Yup.string().required('El curso escolar es obligatorio'),
    id_colegio:             Yup.string().required('El colegio es obligatorio'),
    id_registro_actividad:  Yup.string().required('La actividad es obligatoria'),
    clave:                  Yup.string().required('La clave es obligatoria'),
})